// Archivo: src/pages/LoginPage.js

import React from 'react';
// 1. IMPORTAMOS useNavigate JUNTO A Link
import { Link, useNavigate } from 'react-router-dom';
import LoginForm from '../components/LoginForm';

// --- Componente de Logo (Consistente con el Sidebar) ---
const AppLogo = () => (
    <div className="text-center mb-8">
        <Link to="/quienes-somos" className="inline-block transition-transform duration-300 hover:scale-110" aria-label="Ir a la página Quiénes Somos">
            <img src="/1.svg" alt="Logo Gobierno de Salta" className="h-24 w-auto" />
        </Link>
    </div>
);

// --- Componente de Botón de Regreso ---
const BackButton = () => {
    // 2. INICIALIZAMOS EL HOOK useNavigate
    const navigate = useNavigate();

    return (
        <div className="absolute top-6 left-6 z-10">
            {/* 3. REEMPLAZAMOS <Link> POR <button> Y AÑADIMOS UN onClick */}
            <button 
                onClick={() => navigate(-1)} // Esto navega una página hacia atrás en el historial
                className="group inline-flex items-center gap-2 py-2 px-4 bg-white border border-gray-200 rounded-full shadow-sm hover:shadow-lg hover:border-gob-azul-medio transition-all duration-300"
            >
                <svg className="w-5 h-5 text-gob-azul-medio transition-transform group-hover:-translate-x-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>
                <span className="font-semibold text-sm text-gob-azul-oscuro group-hover:text-gob-azul-medio transition-colors">Volver</span>
            </button>
        </div>
    );
};

export default function LoginPage() {
  return (
    // Contenedor principal con fondo degradado y diseño flexible
    <div className="bg-gradient-to-br from-white to-gob-fondo min-h-screen flex flex-col justify-center items-center p-4 font-sans relative">
      
      <BackButton />

      <main className="w-full max-w-md animate-fade-in-up">
        <div className="bg-white p-10 rounded-2xl shadow-2xl border border-gray-100">
          <AppLogo />
          <header className="text-center mb-8">
            <h1 className="text-4xl font-extrabold text-gob-azul-oscuro tracking-tight">Bienvenido de Nuevo</h1>
            <p className="text-gray-500 mt-2">Inicia sesión para continuar</p>
          </header>
          <LoginForm />
        </div>
      </main>
      
       <footer className="text-center mt-8 text-sm text-gray-400">
            <p>&copy; {new Date().getFullYear()} Gobierno de Salta. Todos los derechos reservados.</p>
      </footer>
    </div>
  );
}

